<template>
  <b-modal
    :id="modalId"
    :visible="visible"
    title="Criar Novo Usuário"
    centered
    hide-footer
    @hide="$emit('close')"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-form-group label="Nome">
        <b-form-input
          v-model="form.nome"
          required
        />
      </b-form-group>

      <b-form-group label="Email">
        <b-form-input
          v-model="form.email"
          type="email"
          required
        />
      </b-form-group>

      <b-form-group label="Senha">
        <b-form-input
          v-model="form.senha"
          type="password"
          required
        />
      </b-form-group>

      <b-form-group label="Lojas que vai atender:">
        <v-select
          v-model="form.selectStore"
          multiple
          label="text"
          value="id"
          :options="stores"
          required
        />
      </b-form-group>

      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="mr-1"
          @click="$emit('close')"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-1"
          />
          Criar
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import { registerAttendent, registerAttendentStores, aceitarConvite } from '../../functions/basics/register'
import stores from '../../functions/basics/stores'

export default {
  name: 'ModalCriarUsuario',
  components: {
    vSelect,
  },
  props: {
    visible: Boolean,
    modalId: {
      type: String,
      default: 'modal-criar-usuario',
    },
  },
  data() {
    return {
      stores: [],
      form: {
        nome: '',
        email: '',
        senha: '',
        selectStore: null,
      },
      loading: false,
    }
  },
  created() {
    this.carregarLojas()
  },
  methods: {
    async carregarLojas() {
      const lojas = await stores()

      this.stores = [
        ...lojas.map(loja => ({
          value: loja.id,
          text: loja.name,
        })),
      ]
      console.log(lojas)
    },
    async handleSubmit() {
      this.loading = true
      try {
        const stores = {}
        const novoAtendente = await registerAttendent(this.form.nome, this.form.email, this.form.senha)
        this.form.selectStore.forEach(store => {
          stores[store.value] = [3, 5, 6]
        })

        const convite = await registerAttendentStores(this.form.email, novoAtendente, stores)

        aceitarConvite(convite.token)
        const novo = {
          id: novoAtendente,
          nome: this.form.nome,
          email: this.form.email,
          criado: new Date().toISOString().substr(0, 10),
        }

        this.$emit('created', novo)
        this.resetForm()
      } catch (error) {
        console.log(error)

        this.loading = false

        this.$bvToast.toast('Algo deu errado!', {
          title: 'Por favor, verifique se o email informado já não foi cadastrado.',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 4000,
        })
      }
    },
    resetForm() {
      this.form = { nome: '', email: '', senha: '' }
      this.loading = false
      this.$emit('close')
    },
  },
}
</script>
